import React from 'react';

interface CrossIconProps {
    width?: number;
    height?: number;
    fill?: string;
}

const CrossIcon = ({ width = 24, height = 24, fill = 'black' }: CrossIconProps) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.47001 5.47C5.61064 5.32955 5.80126 5.25066 6.00001 5.25066C6.19876 5.25066 6.38939 5.32955 6.53001 5.47L18.53 17.47C18.6037 17.5387 18.6628 17.6215 18.7038 17.7135C18.7448 17.8055 18.7668 17.9048 18.7686 18.0055C18.7704 18.1062 18.7519 18.2062 18.7141 18.2996C18.6764 18.393 18.6203 18.4778 18.549 18.549C18.4778 18.6203 18.393 18.6764 18.2996 18.7141C18.2062 18.7518 18.1062 18.7704 18.0055 18.7686C17.9048 18.7668 17.8055 18.7448 17.7135 18.7038C17.6215 18.6628 17.5387 18.6037 17.47 18.53L5.47001 6.53C5.32956 6.38937 5.25067 6.19875 5.25067 6C5.25067 5.80125 5.32956 5.61063 5.47001 5.47Z"
            fill={fill}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.53 5.47C18.6705 5.61063 18.7493 5.80125 18.7493 6C18.7493 6.19875 18.6705 6.38937 18.53 6.53L6.53 18.53C6.38782 18.6625 6.19978 18.7346 6.00548 18.7312C5.81118 18.7277 5.62579 18.649 5.48838 18.5116C5.35096 18.3742 5.27225 18.1888 5.26882 17.9945C5.2654 17.8002 5.33752 17.6122 5.47 17.47L17.47 5.47C17.6106 5.32955 17.8012 5.25066 18 5.25066C18.1987 5.25066 18.3894 5.32955 18.53 5.47Z"
            fill={fill}
        />
    </svg>
);

export default CrossIcon;

